import { useFeatureFlags } from '@builddocs/system'

import { CryptoproCertificate } from '../lib/cryptopro/types'

const EXECUTIVE_POSITIONS = [
  'Руководитель организации',
  'Председатель правления',
  'Президент',
  'Директор',
  'Генеральный директор',
  'Управляющий - индивидуальный  предприниматель',
  'Управляющий - индивидуальный предприниматель',
  'УПРАВЛЯЮЩИЙ ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ',
]

/**
 * Проверяет, требуется ли выбор МЧД для данного сертификата
 * @param certificate - информация о сертификате
 * @param mchdEmployeeSignProtectionIsEnabled - флаг от бекенда (если false, всегда возвращает false)
 * @returns объект с флагом isRequired и опциональной должностью
 */
export const isProxyRequired = (
  certificate: CryptoproCertificate | undefined,
  mchdEmployeeSignProtectionIsEnabled = 'true',
): { isRequired: boolean; position?: string } => {
  // Если флаг отключен - МЧД не требуется
  if (mchdEmployeeSignProtectionIsEnabled !== 'true') {
    return { isRequired: false }
  }

  // Если сертификат не выбран - МЧД не требуется
  if (!certificate) {
    return { isRequired: false }
  }

  // Если есть ОГРНИП (индивидуальный предприниматель) - МЧД не требуется
  if (certificate.Subject?.OGRNIP) {
    return { isRequired: false }
  }

  const position = certificate.Subject?.T

  // Если нет ОГРНИП И нет должности - МЧД обязательно требуется
  if (!position) {
    return { isRequired: true }
  }

  const isExecutive = EXECUTIVE_POSITIONS.some(
    execPosition =>
      position.toLowerCase().trim() === execPosition.toLowerCase().trim(),
  )

  if (isExecutive) {
    return { isRequired: false, position }
  }

  return { isRequired: true, position }
}

/**
 * Хук для проверки требуется ли МЧД для сертификата
 * Автоматически использует флаг mchdEmployeeSignProtectionIsEnabled из контекста
 */
export const useIsProxyRequired = (
  certificate: CryptoproCertificate | undefined,
): { isRequired: boolean; position?: string } => {
  const { data } = useFeatureFlags()

  return isProxyRequired(
    certificate,
    data?.mchdEmployeeSignProtectionIsEnabled ?? 'true',
  )
}
